import { render } from "./Featured.vue?vue&type=template&id=123f2db2&scoped=true&ts=true"
import script from "./Featured.vue?vue&type=script&lang=ts"
export * from "./Featured.vue?vue&type=script&lang=ts"

import "./Featured.vue?vue&type=style&index=0&id=123f2db2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123f2db2"]])

export default __exports__